var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "pb-0", attrs: { cols: "12" } },
            [
              _vm.currentUser.clientType === "Media" ||
              _vm.currentUser.clientType === "Driblab"
                ? _c("MediaModeForm", {
                    attrs: {
                      fields: _vm.mediaModeFields,
                      mediaMode: _vm.mediaMode,
                      mediaModeData: _vm.mediaModeData,
                      mediaModeFlags: _vm.mediaModeFlags,
                      selectorMode: "",
                      showButtons: "",
                    },
                    on: {
                      mediaModeChange: function ($event) {
                        _vm.mediaMode = $event
                      },
                      mediaModeDataChange: function ($event) {
                        return _vm.onMediaModeDataChange($event)
                      },
                      mediaModeFlagsChange: function ($event) {
                        _vm.mediaModeFlags = $event
                      },
                      buttonClicked: function ($event) {
                        return _vm.onMediaFormButtonClicked($event)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "12" } },
            [
              _vm.mediaMode
                ? _c("PlayerAvatarMedia", {
                    ref: "playerAvatarMediaRef",
                    attrs: {
                      width: _vm.avatarSize.width,
                      height: _vm.avatarSize.height,
                      id: `analysis-${_vm.player.id}`,
                      title: _vm.mediaModeData.upperText,
                      subtitle: _vm.mediaModeData.lowerText,
                      color: _vm.mediaModeData.borderColor,
                      bgColor: _vm.mediaModeData.bgColor,
                      textColor: _vm.mediaModeData.textColor,
                      player: _vm.player,
                      face: _vm.mediaModeData.face.dataUrl,
                      nationalTeam: _vm.mediaModeData.nationalTeam,
                      type: "analysis",
                      lineDistance: _vm.mediaModeData.lineLength,
                      avatarSize: _vm.mediaModeData.avatarSize,
                      lineWeight: _vm.mediaModeData.lineWeight,
                      upperTextFontSize: _vm.mediaModeData.upperTextFontSize,
                      upperTextFontWeight:
                        _vm.mediaModeData.upperTextFontWeight,
                      lowerTextFontSize: _vm.mediaModeData.lowerTextFontSize,
                      lowerTextFontWeight:
                        _vm.mediaModeData.lowerTextFontWeight,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.mediaMode
        ? _c(
            "v-row",
            _vm._l(2, function (side) {
              return _c(
                "v-col",
                {
                  key: `header-text-${side}`,
                  staticClass: "py-0",
                  class: { "pr-0 pl-4": side === 1, "pl-0 pr-4": side === 2 },
                  attrs: { cols: "6" },
                },
                [
                  _vm.mediaModeData[`headerText${side}`]
                    ? _c("DriblabSVGText", {
                        ref: "headerTextRef",
                        refInFor: true,
                        staticClass: "w-100",
                        attrs: {
                          text: _vm.mediaModeData[`headerText${side}`],
                          width: null,
                          height: _vm.mediaModeData.chartHeaderFontSize
                            ? _vm.mediaModeData.chartHeaderFontSize * 2.5
                            : 50,
                          id: `header-${side}`,
                          justify: "middle",
                          fontSize: _vm.mediaModeData.chartHeaderFontSize,
                          weight: _vm.mediaModeData.chartHeaderFontWeight,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-row",
        _vm._l(2, function (side) {
          return _c(
            "v-col",
            {
              key: side,
              staticClass: "pt-0",
              class: { "pr-1": side === 1, "pl-1": side === 2 },
              attrs: { cols: "6" },
            },
            [
              _vm.mediaModeData[`chart${side}`] === "finishingMap"
                ? _c("PlayerFinishingMap", {
                    ref: "finishingMapRef",
                    refInFor: true,
                    attrs: {
                      playerId: _vm.player.id,
                      headerPlayer: _vm.player,
                      chartId: Number(`1${side}`),
                      stackedView: "",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.mediaModeData[`chart${side}`] === "keyPassMap"
                ? _c("PlayerKeyPassMap", {
                    ref: "keyPassMapRef",
                    refInFor: true,
                    attrs: {
                      playerId: _vm.player.id,
                      chartId: Number(`2${side}`),
                      stackedView: "",
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }